import React from "react";

const StroyIcon = ({
  viewBox = "0 0 24 24",
  color = "#696cff",
  size = 24,
  ...props
}) => (
  <svg
    viewBox="0 0 1024 1024"
    p-id="14085"
    width={size}
    height={size}
    {...props}
  >
    <path
      d="M967.090176 396.722176c7.395328-33.284096-49.926144-81.360896-72.116224-3.69664-16.64 53.622784 5.548032 79.511552-1.847296 85.057536-7.397376 5.545984-279.218176 334.690304-323.59424 386.465792-64.720896-20.338688-323.596288-94.304256-403.10784-120.193024-81.360896-48.0768-51.777536-173.815808 5.545984-157.17376 38.83008 11.094016 290.310144 85.057536 334.688256 98.004992 42.530816 12.941312 59.172864 22.19008 90.607616-16.644096 44.376064-53.624832 323.596288-373.522432 356.880384-408.653824 24.035328-27.736064 33.282048-66.568192-18.49344-75.814912-53.624832-11.094016-358.72768-83.208192-403.105792-90.605568-42.528768-7.395328-53.624832-18.489344-96.1536 33.284096C414.205952 154.488832 133.138432 468.8384 96.157696 507.670528 55.476224 550.199296-3.694592 751.753216 140.535808 807.225344c144.2304 49.926144 321.746944 99.852288 403.10784 123.891712 36.984832 11.094016 61.022208 16.64 83.212288-20.342784 22.188032-36.982784 310.65088-371.67104 332.84096-401.256448 20.340736-27.736064 9.244672-3.698688 3.698688-53.624832-5.552128-49.926144-1.851392-33.282048 3.694592-59.170816z m-543.639552-125.741056c16.642048-20.340736 18.489344-24.037376 24.037376-29.585408 16.642048-16.642048 36.982784-12.94336 55.474176-9.24672 12.94336 1.849344 218.195968 53.624832 231.13728 55.474176 12.945408 3.698688 51.777536 9.244672 31.4368 33.284096-22.188032 25.888768-20.340736 24.037376-27.736064 31.434752-7.39328 7.395328-24.037376 12.94336-51.77344 5.545984-24.039424-7.395328-221.894656-53.624832-238.538752-55.472128-16.64-1.847296-40.679424-11.091968-24.037376-31.434752z"
      fill={color}
      p-id="14086"
    ></path>
  </svg>
);

export default StroyIcon;
